import type { Item } from '../hp/types';

/**
 * The app's sloped ceiling, the mansard (primitive 1495; `src/state/attic.ts` has the rest). Its pivot is the top
 * of its back edge, which stands on a wall: its footprint runs from there across its depth, not round its middle.
 */
export const ATTIC_MODEL = 'decor.primitives/1495/1495';
export const isAttic = (item: Pick<Item, 'modelRef'>): boolean => item.modelRef.kind === 'local' && item.modelRef.id === ATTIC_MODEL;
